export default "__VITE_ASSET__VY6RnFDP__"